// extracted by mini-css-extract-plugin
module.exports = {"Onboarding":"Onboarding_Onboarding__GRi2I","progressBarHeader":"Onboarding_progressBarHeader__fTydt"};